import React from "react";

import { Alert, AlertColor } from "@mui/material";

export const StandaloneInfo = ({severity, text}: {severity: AlertColor, text: string}) =>
    <Alert sx={{mt: 16}} severity={severity}>{text}</Alert>